import type { FormEvent } from 'react';

import { Checkbox, LinkButton } from '@dot/design-system';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

import { Buttons } from './buttons';

import { fontTextXsRegular } from '@/styles/helpers';

const CheckboxWrapper = styled.div`
  max-width: 500px;
  margin-inline: auto;
  margin-top: 30px;
`;

const PrivacyPolicyLinkButton = styled(LinkButton)`
  ${fontTextXsRegular};
`;

type FormProps = {
  onFinish: () => void;
};

export const Form = ({ onFinish }: FormProps) => {
  const { t } = useTranslation();
  const [consent, setConsent] = useState(false);

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (!consent) {
      return;
    }

    onFinish();
  }

  return (
    <form onSubmit={handleSubmit}>
      <CheckboxWrapper>
        <Checkbox
          checked={consent}
          data-test-id={consent ? 'check_checked' : 'check_default'}
          onChange={(e) => setConsent(e.target.checked)}
        >
          {t('steps.introduction.consent')}
          <PrivacyPolicyLinkButton href={t('steps.introduction.privacyPolicyHref')} target="_blank">
            {t('steps.introduction.privacyPolicyButton')}
          </PrivacyPolicyLinkButton>
        </Checkbox>
      </CheckboxWrapper>
      <Buttons disabled={!consent} />
    </form>
  );
};
